var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99974 2.66699C11.5739 2.66699 14.6383 4.86772 15.9331 7.99869C14.6383 11.1297 11.5739 13.3304 7.99974 13.3304C4.42561 13.3304 1.36121 11.1297 0.0664062 7.99869C1.36121 4.86772 4.42561 2.66699 7.99974 2.66699ZM7.99974 4.00033C5.23494 4.00033 2.75691 5.57615 1.53226 7.99869C2.75691 10.4212 5.23494 11.9971 7.99974 11.9971C10.7645 11.9971 13.2426 10.4212 14.4672 7.99869C13.2426 5.57615 10.7645 4.00033 7.99974 4.00033ZM7.99974 4.66699C9.84069 4.66699 11.3331 6.15938 11.3331 8.00033C11.3331 9.84127 9.84069 11.3337 7.99974 11.3337C6.15879 11.3337 4.66641 9.84127 4.66641 8.00033C4.66641 6.15938 6.15879 4.66699 7.99974 4.66699ZM7.99974 6.00033C6.89517 6.00033 5.99974 6.89576 5.99974 8.00033C5.99974 9.1049 6.89517 10.0003 7.99974 10.0003C9.10431 10.0003 9.99974 9.1049 9.99974 8.00033C9.99974 6.89576 9.10431 6.00033 7.99974 6.00033Z",
    fill: "#9E007E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.17bb3fa9673760c540e39f3eb97b9d77.svg";
export { ForwardRef as ReactComponent };